import { Box, Paper, Typography, IconButton } from "@mui/material";
import FindInPageOutlined from "@mui/icons-material/FindInPageOutlined";
import makeStyles from '@mui/styles/makeStyles';
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { ListagemItem } from "src/components/projetos/types";
import { VALOR_MULTIPLO_CABO } from "src/components/projetos/constants";
import { ID_CABO } from "src/components/componentes/types";
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";
import { quantidadesMinimas$ } from "../../..";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

export interface ComponentsListMobileProps {
  projetoFiname: boolean;
  solucaoData: ListagemItem[];
  mostrarColunasAdicionais: boolean;
  temPermissaoCodigoComponente: boolean;
  checkError: (id: number, qtd: number) => boolean;
  handleChangeQuantity: (id: number, value: string) => void;
}

const useStyles = makeStyles({
  container: {
    width: '100%'
  },

  card: {
    padding: 15,
    borderRadius: 12,
    marginBottom: 25,
  },

  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    paddingLeft: 5
  },

  componenteInfo: {
    flex: 1,
    textAlign: "left",
  },

  infoTexto: {
    marginBlock: 3
  },

  attention: {
    color: "#c47a00",
    fontWeight: 600,
  },

  inputQuantidade: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    position: "relative",
    left: "-20px"
  },

  detailsButton: {
    textAlign: "right",
    position: "relative",
    top: 3,
  },

  rowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15
  }
});

export default function ComponentesListMobile({
  checkError,
  solucaoData,
  projetoFiname,
  handleChangeQuantity,
  mostrarColunasAdicionais,
  temPermissaoCodigoComponente,
}: ComponentsListMobileProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {solucaoData?.map((row) => {
        const temRegraIndicacao = !!row?.regra_indicacao?.length;
        let quantidadeMinima = 0
        if (projetoFiname) {
          const tipoCaboAttr = (row.atributos || []).find(item => item.atributo === 'TIPO_CABO')
          const tipoCabo = tipoCaboAttr ? Number(tipoCaboAttr?.valor) : null;
          const ignorarRegraQtdMinima = tipoCabo === 3;

          if (!ignorarRegraQtdMinima) {
            quantidadeMinima = quantidadesMinimas$.getValue().find(qt => qt.componente_id === row.componente_id)?.quantidade || 0
            if (row.categoria_componentes_id === ID_CABO) {
              quantidadeMinima = VALOR_MULTIPLO_CABO
              if (row.quantidade === 0) {
                row.quantidade = VALOR_MULTIPLO_CABO
              }
            }
          }
        }
        return (
          <Paper key={row.componente_id} className={classes.card} elevation={1}>
            <Box className={classes.cardHeader}>
              <Box className={classes.componenteInfo}>
                <Typography variant="body1" style={{ fontWeight: 600 }} className={classes.infoTexto}>
                  {temPermissaoCodigoComponente ? (`${row.componente_id} - ${row.nome}`) : row.nome}
                </Typography>

                {row.descricao && (
                  <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                    <span className={classes.attention}>Informações</span>: {row.descricao}
                  </Typography>
                )}

                {mostrarColunasAdicionais && (
                  <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                    {Formater.toString(row.valor_unitario, TypeRecords.CURRENCY)}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box className={classes.rowBox}>
              <Box className={classes.inputQuantidade}>
                <InputQuantidade
                  minValue={quantidadeMinima}
                  hasError={checkError(row.categoria_componentes_id, row.quantidade)}
                  multiple={row.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1}
                  disabledInput={false}
                  highlightField={false}
                  disabled={[1, 2].includes(row.categoria_componentes_id) || temRegraIndicacao }
                  value={row.quantidade}
                  onChange={(v: any) => handleChangeQuantity(row.componente_id, v)}
                  onBlur={(v: any) => {
                    if (projetoFiname && (!v || Number(v) < quantidadeMinima)) {
                      handleChangeQuantity(row.componente_id, quantidadeMinima.toString())
                    }
                  }}
                />
              </Box>

              <Box className={classes.detailsButton}>
                <IconButton
                  onClick={() => modalComponentesDetalhesData$.next(row.componente_id)}
                  size="large">
                  <FindInPageOutlined htmlColor="black" fontSize="large" />
                </IconButton>
              </Box>
            </Box>
            <Box textAlign="left" marginTop={1} marginLeft={1}>
              {row.categoria_componentes_id === ID_CABO && checkError(row.categoria_componentes_id, row.quantidade) && (
                <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
              )}
            </Box>
          </Paper>
        );}
      )}
    </Box>
  );
}